import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../setting/user/user-setting.css';
import './reimbursemnt-method.css';
import { Button, message, Modal, Typography } from 'antd';
import CardIcon from '../../../assets/card.svg';
import PaperCheckIcon from '../../../assets/paper-check.svg';
import TrashIcon from '../../../assets/trash-icon.svg';
import WarningIcon from '../../../assets/warning-icon.svg';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import LilyButton from '../../../components/button/lily-button';
import { DELETE_REIMBURSEMENT_URL } from '../../../api/URLs';
import { updateUser } from '../../../stores/authenticated-user.store';
import portalAPI from '../../../api/api';
import BackButton from '../../../components/button/back-button';

const ReimbursementMethodsPage = () => {
    const user = useSelector((state) => state.authenticatedUser);
    const dispatch = useDispatch();
    const { Text, Title } = Typography;
    const navigate = useNavigate();
    const [checkData, setCheckData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [modalDelete, setModalDelete] = useState({
        isOpen: false,
        content: {},
        id: "",
    })
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        if (!user) return;
        let entityCheck = user?.reimbursementMethods?.find((item) => item.method === "check-by-mail");
        let entityAccounts = user?.reimbursementMethods?.filter((item) => item.method === "direct-deposit");
        if (entityAccounts && entityAccounts.length > 0) {
            setAccounts(entityAccounts);
        } else {
            setAccounts([])
        }
        if (entityCheck) {
            setCheckData(entityCheck);
        }
    }, [user]);

    const handleCancel = () => {
        setModalDelete({
            isOpen: false,
            content: {}
        })
    }

    const handleUnlinkBank = async () => {
        setIsLoading(true);
        try {
            const reimbursement_id = modalDelete.id;
            if (!reimbursement_id) {
                message.error('Check ID not found');
                return;
            }

            const response = await portalAPI.put(DELETE_REIMBURSEMENT_URL, { reimbursement_id });

            if (response.data.status === 200) {
                dispatch(updateUser({
                    key: 'reimbursementMethods',
                    value: response.data.data.reimbursementMethods,
                }));
                message.success("You have successfully unlinked the bank account.");
                setIsLoading(false);
                handleCancel();
            }
        } catch (error) {
            message.error('Submit failed:', error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className='user-setting-layout'>
            <div className='w-100'>
                <BackButton path='/dashboard' />
            </div>
            <div className='w-100 d-flex justify-content-center mt-4'>
                <div className='rm-body d-flex flex-column gap-3'>
                    <div className='d-flex flex-column align-items-start gap-1'>
                        <Title className='mb-0 main-title' level={3}>
                            Reimbursement Methods
                        </Title>
                        <Text>
                            Save your payment information to get reimbursed faster. You can update this information anytime.
                        </Text>
                    </div>
                    <div className='row g-3'>
                        {
                            accounts.length > 0 && accounts.map((item) => {
                                let data = item.directDeposit;
                                let routingNumber = data?.bankTransferCode?.find((item) => item.type === 'ROUTING_NUMBER');
                                return (
                                    <div className='col-md-6 col-12'>
                                        <div className='method-card'>
                                            <div className='d-flex flex-row align-items-start gap-3'>
                                                <img src={CardIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                                                <div className='d-flex flex-column'>
                                                    <Title level={5} style={{ fontWeight: '500' }}>Direct Deposit (ACH)</Title>
                                                    <Text strong>{data.providerName}</Text>
                                                    <Text>Account Name: {data.accountName}</Text>
                                                    <Text>Account Type: {data.accountType}</Text>
                                                    <Text>Account Number: {data.accountNumber}</Text>
                                                    <Text>Routing Number: {routingNumber?.id || 'N/A'}</Text>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-row justify-content-end w-100'>
                                                <Button onClick={() => {
                                                    setModalDelete({
                                                        isOpen: true,
                                                        content: {
                                                            type: "link",
                                                            title: "Unlink External Bank Account?",
                                                            description: `Are you sure you want to unlink your Bank Account - ${data.providerName}? You will no longer be able to transfer funds to this account.`
                                                        },
                                                        id: item._id
                                                    })
                                                }}
                                                    icon={<img alt='trash-icon' className='mb-1' src={TrashIcon} />}
                                                    className='unlink-btn'
                                                >
                                                    Unlink Account
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className='col-md-6 col-12'>
                            <div className='method-card'>
                                <div className='d-flex flex-row align-items-start gap-3'>
                                    <img src={CardIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                                    <div className='d-flex flex-column'>
                                        <Text style={{ fontWeight: '500' }}>Link a Bank Account</Text>
                                        <Text>
                                            Secure Connection
                                            We use Yodlee to securely connect to your bank. Your credentials are encrypted and never stored.
                                        </Text>
                                    </div>
                                </div>
                                <div className='d-flex flex-row justify-content-end w-100'>
                                    <Button onClick={() => navigate("/setting/reimbursement-methods/link-account")} icon={<PlusOutlined />} className='add-card-btn'>Link Bank Account</Button>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 col-12'>
                            <div className='method-card'>
                                <div className='d-flex flex-row align-items-start gap-3'>
                                    <img src={PaperCheckIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                                    <div className='d-flex flex-column'>
                                        <Text style={{ fontWeight: '500' }}>Check by Mail</Text>
                                        <Text>
                                            Checks will be mailed to this address.
                                        </Text>
                                        <Text>{`Recipient: ${checkData?.checkByMail?.recipientName || 'N/A'}`}</Text>
                                        <Text>{`Address: ${checkData?.checkByMail?.address1}`}</Text>
                                        {
                                            checkData?.checkByMail?.address2 && (
                                                <Text>{`${checkData?.checkByMail?.address2}`}</Text>
                                            )
                                        }
                                        <Text>{`${checkData?.checkByMail?.city}, ${checkData?.checkByMail?.state}`}</Text>
                                        <Text>{`${checkData?.checkByMail?.zip}`}</Text>
                                    </div>
                                </div>
                                <div className='d-flex flex-row justify-content-end w-100'>
                                    <Button onClick={() => navigate("/setting/reimbursement-methods/edit-check")} icon={<PlusOutlined />} className='add-card-btn'>Change Mailing Address</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={modalDelete.isOpen}
                onCancel={handleCancel}
                width={600}
                centered
                footer={null}
            >
                <div className='d-flex flex-column align-items-center gap-3' style={{ padding: '0 50px' }}>
                    <img alt='logo' src={WarningIcon} style={{ width: '50px', height: '100%' }} />
                    <div className='d-flex flex-column align-items-center gap-1'>
                        <Title level={5} className='text-center m-0'>{modalDelete?.content?.title || ''}</Title>
                        <Text className='text-center m-0'>{modalDelete?.content?.description || ''}</Text>
                    </div>
                    <div className='d-flex flex-row align-items-center gap-2'>
                        <Button disabled={isLoading} onClick={handleCancel}>No, Cancel</Button>
                        <LilyButton loading={isLoading} onClick={handleUnlinkBank} text="Yes, Unlink Account" style={{ borderRadius: '5px' }} />
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ReimbursementMethodsPage